<template>
  <oie-my-pages-template :title="t('myUsersTitle')" :text="t('myUsersSubTitle')">
    <oie-action-wrapper>
      <template #left>
        <div>
          <p class="body-semi-bold body-blue">
            {{ get(clientModel, ['user', 'name']) }}
          </p>
          <p class="body">
            {{ get(clientModel, ['user', 'customerNumber']) }}
          </p>
        </div>
      </template>
      <template>
        <oie-invite-user-slide-in></oie-invite-user-slide-in>
      </template>
    </oie-action-wrapper>
    <oie-action-wrapper>
      <template #left>
        <oie-base-input :value="filter" :placeholder="t('searchUsersPlaceholder')" @input="setFilter">
          <template #iconPrepend>
            <oie-base-icon icon="filter-icon" size="s"></oie-base-icon>
          </template>
        </oie-base-input>
      </template>
    </oie-action-wrapper>
    <div v-if="users" class="my-users__content">
      <oie-my-machines-list-wrapper>
        <li v-for="(user, index) in filteredUsers" :key="index">
          <oie-user-item
            :user="user"
            @select-user="handleSelectUser(user)"
            @cancel-invite="handleCancelInvite(user)"
            @user-updated="handleUserUpdated()"></oie-user-item>
        </li>
      </oie-my-machines-list-wrapper>
    </div>
  </oie-my-pages-template>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import myPages from '@/mixins/my-pages'
import httpService from '@/core/http-service'

export default {
  mixins: [myPages],
  computed: {
    ...mapGetters('myUsers', ['users', 'filter', 'filteredUsers'])
  },
  mounted() {
    this.getUsers()

    this.subscribe('my-users-invited-new-user', () => {
      this.getUsers()
    })
  },
  methods: {
    ...mapActions('myUsers', ['getUsers', 'setCurrentUser', 'setFilter']),
    handleSelectUser(user) {
      this.setCurrentUser(user)
      this.goToSubPage(this.navigationOptions.oieEditUser)
    },
    handleCancelInvite(user) {
      httpService.post('auth/myusers/invite/cancel', { email: user.email }).then((response) => {
        this.getUsers()
      }).catch((error) => {
        if (error.response.status === 409) {
        }
      })
    },
    handleUserUpdated() {
      this.setCurrentUser(null)
      this.getUsers()
    }
  }
}
</script>
